import type { ReadOnlyAccountScopeUserSettings } from 'owa-service/lib/types/AccountScopeUserSettings';
import { getStore } from '../store/store';
import assert from 'owa-assert/lib/assert';

export function getAccountScopeUserSettings(sourceId: string): ReadOnlyAccountScopeUserSettings {
    const accountScopeUserSettings = getStore().accountScopeUserSettingsMap.get(sourceId);
    assert(!!accountScopeUserSettings);
    return accountScopeUserSettings;
}
